import { phone } from '@polvo-labs/form-utils'
import { Fetch } from '@polvo-labs/react-auth'
import React, { useState } from 'react'
import { confirm } from '../../../../components/Dialog'
import Loader from '../../../../components/Loader'
import Pagination from '../../../../components/Pagination'
import Table from '../../../../components/Table'
import UserType from '../../../../models/User'
import Filter from './Filter'
import { Container } from './styles'

interface Props {
  onSelect: (user: any) => void
}

const AdminListScreen: React.FC<Props> = ({ onSelect }) => {
  const [apiUrl, setApiUrl] = useState(`${process.env.REACT_APP_API_URL}/users?role=1`)
  const [params, setParams] = useState({})

  return (
    <div
      style={{ padding: '20px' }}
    >
      <Filter
        filters={['text']}
        onChange={setParams}
      />
      <Fetch
        url={apiUrl}
        params={params}
        loader={() => (
          <Loader
            darkMode
          />
        )}
      >
        {({ data }) => data && data.data ? (
          <Container>
            {data.data.length ? (
              <>
                <Table
                  header={[
                    'ID',
                    'Nome',
                    'Telefone',
                  ]}
                  items={data.data.map((user: UserType) => [
                    user.id,
                    user.name,
                    phone.format(user.phone),
                  ])}
                  onClick={user => {
                    confirm({
                      title: 'Comfirme',
                      message: `Você tem certeza de selecionar o usuário ${user[1]}?`,
                      buttons: [
                        {
                          label: 'Sim',
                          onClick: () => {
                            onSelect(user)
                          },
                        },
                        {
                          label: 'Não',
                          onClick: () => { },
                        },
                      ],
                    })
                  }}
                />

                <Pagination
                  meta={data.meta}
                  links={data.links}
                  onChange={setApiUrl}
                />
              </>
            ) : (
              <span>Nenhum resultado encontrado</span>
            )}
          </Container>
        ) : (
          <span>
              Error
          </span>
        )}
      </Fetch>
    </div>
  )
}

export default AdminListScreen
